export default __webpack_public_path__ + "static/media/Ballroll_00095.766dbcce.png";